import { render, staticRenderFns } from "./GH.vue?vue&type=template&id=82968040&scoped=true"
import script from "./GH.vue?vue&type=script&lang=js"
export * from "./GH.vue?vue&type=script&lang=js"
import style0 from "./GH.vue?vue&type=style&index=0&id=82968040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82968040",
  null
  
)

export default component.exports